<template>
  <div class="login-form__features">
    <span class="login-form__feature font-bold">
      Регистрация сделает использование платформы удобнее и ярче! 🚀
    </span>
    <span class="login-form__feature">
      ✍️ Делитесь своими идеями
    </span>
    <span class="login-form__feature">
      💬 Участвуйте в обсуждениях
    </span>
    <span class="login-form__feature">
      ⭐️ Сохраняйте избранное
    </span>
  </div>
  <form @submit.prevent="sendForm" class="form">
    <ImageUpload v-model="form.photo" title="Ваше фото" />
    <v-input v-model="form.name" label="Имя" />
    <v-input type="email" v-model="form.email" label="Email" />
    <v-input type="password" v-model="form.password" label="Пароль" />
    <button type="submit" class="btn btn--full">Зарегистрироваться</button>
    <p class="form__text">
      Регистрируясь в нашем приложении, вы соглашаетесь с <router-link :to="{name:'agreement'}">пользовательским соглашением</router-link>
    </p>
  </form>
</template>
  
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { userService } from '@/http'
import store from '@/store'

import ImageUpload from '@/Components/ImageUpload.vue'

const emit = defineEmits()

const router = useRouter()
const form = ref({})

const sendForm = async () => {
  userService.signup({...form.value}).then(data => {
    //localStorage.setItem('token', data.data)
    store.login(data)
    emit('auth')
    // router.push({
    //   name: 'index'
    // })
  })
}
</script>